import { get, post } from 'services/api-client';

const patientService = {
  createProfile: (data) => post(`/patient/create/profile`, data),

  getByUserId: (userId) => get(`/patient/user/${userId}`),

  getById: (id) => get(`/patient/${id}`),

  getAsSelectListItems: (clientId, showDateOfBirth = false) => get(`/patient/select-list?showDateOfBirth=${showDateOfBirth}&clientId=${clientId}`)
}

export default patientService;